module.exports = __webpack_public_path__ + "img/europe.5daefb4e.svg";